import React, { useState } from 'react';
import client from '../api/client';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await client.post('/api/contact', form);
      setSent(true);
    } catch {
      setError('Could not send message. Please try again.');
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="info-page" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>&#10003;</div>
        <h1>Message Sent</h1>
        <p>Thanks for reaching out. We'll get back to you as soon as we can.</p>
      </div>
    );
  }

  return (
    <div className="info-page">
      <p className="mono" style={{ color: 'var(--gold)', marginBottom: '8px' }}>GET IN TOUCH</p>
      <h1>Contact Us</h1>
      <p>Have a question about your order or our products? Drop us a line.</p>

      {error && <p className="form-error" style={{ marginBottom: '16px' }}>{error}</p>}

      <form onSubmit={handleSubmit} style={{ marginTop: '24px' }}>
        <div className="form-group">
          <label className="form-label">Name</label>
          <input className="form-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
        </div>
        <div className="form-group">
          <label className="form-label">Message</label>
          <textarea className="form-input" rows="6" value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} required />
        </div>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
}
